// Copyright (c) 2016 Deere & Company

import OpenPipPrograms from '../../../reports/open-pip-programs/state-connector';

export default {
    component: OpenPipPrograms,
    name: 'OPEN_PIP_PROGRAMS',
    path: 'open-pip-programs'
};



// WEBPACK FOOTER //
// ./src/routes/pips/reports/open-pip-programs.js